// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import jobApi from '~/apis/job';
import {
  CHANGE_STATUS,
  CREATE_JOB,
  DELETE_JOB,
  GET_JOB_DETAIL,
  GET_JOB_DETAIL_UPDATE,
  GET_JOB_LIST,
  GET_JOB_LIST_BY_CUSTOMER,
  GET_SCHEDULE_LIST_BY_JOB,
  UPDATE_JOB,
} from '~/utils/constants/actionType';
import { IBaseDeleteBody, IQueryParamById } from '~/utils/interface/common';
import {
  IChangeStatusJobBody,
  IFormJob,
  IJobDetailUpdateReq,
  IParamScheduleForJobDetail,
  IParamsDetailJob,
  IQueryGetListJob,
  IUpdateJobBody,
} from '~/utils/interface/job';

export const createJob = createAsyncThunk(CREATE_JOB, async (payload: IFormJob, { rejectWithValue }) => {
  try {
    const res = await jobApi.createJob(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getJobList = createAsyncThunk(
  GET_JOB_LIST,
  async (params: IQueryGetListJob, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getJobList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJobDetail = createAsyncThunk(
  GET_JOB_DETAIL,
  async (params: IParamsDetailJob, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getJobDetail(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJobListByCustomer = createAsyncThunk(
  GET_JOB_LIST_BY_CUSTOMER,
  async (body: IQueryParamById, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getJobListByCustomer(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScheduleJobList = createAsyncThunk(
  GET_SCHEDULE_LIST_BY_JOB,
  async (params: IParamScheduleForJobDetail, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getScheduleList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteJob = createAsyncThunk(
  DELETE_JOB,
  async (params: IBaseDeleteBody, { rejectWithValue }) => {
    try {
      const resp = await jobApi.deleteJob(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateJob = createAsyncThunk(UPDATE_JOB, async (params: IUpdateJobBody, { rejectWithValue }) => {
  try {
    const resp = await jobApi.updateJob(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const changeStatusJob = createAsyncThunk(
  CHANGE_STATUS,
  async (params: IChangeStatusJobBody, { rejectWithValue }) => {
    try {
      const resp = await jobApi.changeStatus(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJobDetailUpdate = createAsyncThunk(
  GET_JOB_DETAIL_UPDATE,
  async (payload: IJobDetailUpdateReq, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getJobDetailUpdate(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
